const elemento = {};
const setStatus = (user, status) => elemento[user] = status
const getStatus = () => {
    return {
        'ativo': Object.entries(elemento).filter((el) => el[1] == 'ativo').length,
        'deslogado': Object.entries(elemento).filter((el) => el[1] == 'deslogado').length,
        'ligacao': Object.entries(elemento).filter((el) => el[1] == 'ligacao').length,
        'pausa': Object.entries(elemento).filter((el) => el[1] == 'pausa').length,
        'chat': Object.entries(elemento).filter((el) => el[1] == 'chat').length,
    }
}

module.exports = {
    elemento,
    getStatus,
    setStatus
}
